import type { InsertStones } from '@/lib/api/schemas/inventory.schema'

function stoneText(stone: InsertStones['stones'][number]): string {
  const weight = stone.weight === null ? null : stone.unit === 'ct' ? `${stone.weight} кт` : stone.weight
  return [stone.count === null ? null : `${stone.count} ×`, stone.kind, weight, stone.grade === null ? null : `(${stone.grade})`]
    .filter((part): part is string => part !== null)
    .join(' ')
}

/** The stone spec as 1C writes it; a spec 1C cut at its length limit says so. */
export function insertStonesText(stones: InsertStones): string {
  const text = stones.stones.map(stoneText).join(', ')
  if (stones.complete) return text
  return text === '' ? 'описание в 1С обрезано' : `${text}, … (описание в 1С обрезано)`
}
